
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("gSGR3", function(module, exports) {

$parcel$export(module.exports, "DashboardsContentViewQuery", () => $7d8146b84d35c151$export$bf90b08b5380f35c);

var $azFkr = parcelRequire("azFkr");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2tacr = parcelRequire("2tacr");
function $7d8146b84d35c151$export$bf90b08b5380f35c({ queries: { queryRef: queryRef } }) {
    const data = (0, $8Uumt.usePreloadedQuery)((0, $azFkr.default), queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2tacr.DashboardsContent), {
        queryRef: data
    });
}

});
parcelRegister("azFkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc04cf6edfa8673b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<76cb6444f1372f8646d016b4de6cea5d>>
 * @relayHash 9a58486151638f4e45660f746394b248
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d

var $eiowN = parcelRequire("eiowN");
const $bc04cf6edfa8673b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraDashboard"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v2 /*: any*/ 
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                }
            ]
        }
    ], v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "DashboardsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "DashboardsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "DashboardsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "dashboardFavourites",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "DASHBOARD"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v3 /*: any*/ 
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "dashboardRecents",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "DASHBOARD"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v3 /*: any*/ 
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d",
            "metadata": {},
            "name": "DashboardsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bc04cf6edfa8673b$var$node.hash = "2a6d30dd0ebce8d8b8a64e7710f0879f";
(0, $eiowN.PreloadableQueryRegistry).set($bc04cf6edfa8673b$var$node.params.id, $bc04cf6edfa8673b$var$node);
var $bc04cf6edfa8673b$export$2e2bcd8739ae039 = $bc04cf6edfa8673b$var$node;

});



//# sourceMappingURL=nav4-dashboards-content-entry-point.2c40e0ff.js.map
